import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Avatar from './ui/Avatar';
import OrderStatusBadge from './OrderStatusBadge';
import PhotoPlaceholder from './ui/PhotoPlaceholder';

export default function OrderCard({ order, viewAs }) {
  const navigate = useNavigate();
  const listing = order.listing || order.listings;
  const isGuestOrder = viewAs !== 'customer' && !order.customer_id;
  const other = viewAs === 'customer'
    ? (order.provider || listing?.users)
    : (isGuestOrder ? { first_name: order.guest_first_name, last_name: order.guest_last_name } : (order.customer || order.users));
  const displayName = other ? `${other?.first_name || ''} ${other?.last_name || ''}`.trim() : '';
  const [imgError, setImgError] = useState(false);

  const formattedScheduledAt = order.scheduled_at
    ? new Date(order.scheduled_at).toLocaleString('en-AE', {
        weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
      })
    : null;

  return (
    <div
      onClick={() => navigate(`/orders/${order.id}`)}
      className="bg-white border border-sand-200 rounded-lg shadow-card hover:shadow-hover hover:-translate-y-0.5 transition-all duration-200 cursor-pointer p-4 flex gap-4 items-start"
    >
      {listing?.cover_photo_url && !imgError ? (
        <img
          src={listing.cover_photo_url}
          alt={listing?.title}
          className="w-16 h-16 rounded-lg object-cover shrink-0 bg-sand-100"
          onError={() => setImgError(true)}
        />
      ) : (
        <div className="w-16 h-16 rounded-lg shrink-0 bg-sand-100">
          <PhotoPlaceholder small />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <p className="font-heading text-sm font-semibold text-ink-900 line-clamp-1 mb-0.5">{listing?.title}</p>
        <p className="text-xs text-ink-400 mb-2">{listing?.category}</p>
        {formattedScheduledAt && (
          <p className="text-xs text-ink-500 mb-2">{formattedScheduledAt}</p>
        )}
        <OrderStatusBadge status={order.status} />
      </div>
      {other && (
        <div className="flex flex-col items-center gap-1 shrink-0">
          <Avatar
            src={other?.avatar_url}
            name={displayName}
            size="sm"
          />
          {displayName && (
            <span
              title={displayName}
              className="text-xs text-ink-500 text-center leading-tight max-w-[56px] truncate"
            >
              {displayName}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
